import {
	headerMobileLinkBoldSX,
	headerMobileSupportLinksContainerSX,
} from '@/components/content/Header/styles/mobileDrawer';
import { Box } from '@mui/material';
import { MobileLink } from '@/components/content/Header/parts/MobileLink';

const linksToSupport = [
	{
		name: '01 800 0028 774',
		icon: (
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
				<path
					id="phone"
					d="M99.208,102.917a13.786,13.786,0,0,0,5.875,5.875l1.958-1.958a.855.855,0,0,1,.917-.208,10.074,10.074,0,0,0,3.167.5A.854.854,0,0,1,112,108v3.125a.854.854,0,0,1-.875.875A15.151,15.151,0,0,1,96,96.875.854.854,0,0,1,96.875,96H100a.854.854,0,0,1,.875.875,9.886,9.886,0,0,0,.5,3.167.943.943,0,0,1-.208.917Z"
					transform="translate(-96 -96)"
					fill="currentColor"
				/>
			</svg>
		),
		href: 'tel:800028774',
	},
	{
		name: '66 99 15 53 00',
		icon: (
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 18.289 18.376">
				<path
					id="iconmonstr-whatsapp-1"
					d="M.057,18.376l1.292-4.719A9.105,9.105,0,1,1,4.885,17.11L.057,18.376Zm5.051-2.915a7.551,7.551,0,1,0-2.1-2.042l-.765,2.793,2.865-.751Zm8.719-4.184c-.057-.095-.208-.152-.436-.266s-1.346-.665-1.555-.74-.36-.114-.512.114-.588.74-.72.892-.266.171-.493.057A6.21,6.21,0,0,1,8.279,10.2,6.849,6.849,0,0,1,7.014,8.628c-.132-.227-.014-.351.1-.464s.227-.266.341-.4a1.492,1.492,0,0,0,.23-.379.418.418,0,0,0-.019-.4c-.057-.113-.512-1.233-.7-1.689s-.373-.384-.512-.39L6.015,4.9a.834.834,0,0,0-.606.285,2.553,2.553,0,0,0-.8,1.9,4.428,4.428,0,0,0,.929,2.354,10.144,10.144,0,0,0,3.887,3.436,13.165,13.165,0,0,0,1.3.479,3.127,3.127,0,0,0,1.433.09,2.344,2.344,0,0,0,1.536-1.082,1.9,1.9,0,0,0,.132-1.083Z"
					transform="translate(-0.057)"
					fill="currentColor"
				/>
			</svg>
		),
		target: '_blank',
		href: 'https://wa.me/523339624683?text=Hola tienda en línea dportenis, me contacto desde su sitio principal',
	},
];

export const SupportLinks = () => (
	<Box sx={headerMobileSupportLinksContainerSX}>
		{linksToSupport.map(({ href, icon, name, target }) => (
			<MobileLink
				href={href}
				icon={icon}
				key={href}
				name={name}
				target={target}
				sx={headerMobileLinkBoldSX}
			/>
		))}
	</Box>
);
